export default {
    title: 'Exports',
    description: 'Chaque export de la médiathèque de l’organisation est consigné ici — ceux de chaque espace de travail comme ceux de toute l’organisation — avec qui l’a demandé, quand et d’où.',
    formTitle: 'Exporter toute la médiathèque',
    formDescription: 'Une ligne par asset, dans tous les espaces de travail — assets en attente et refusés compris, corbeille exclue. Le fichier est préparé en arrière-plan et vous est envoyé par e-mail dès qu’il est prêt.',
    disabled: 'Les exports de la médiathèque ne sont pas activés pour cette organisation. Le journal des exports passés reste consultable ci-dessous.',
}
